function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Lekarstwa");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.253 13.465a4.319 4.319 0 0 0-3.064-1.27 4.319 4.319 0 0 0-3.064 1.27l-7.66 7.66a4.332 4.332 0 0 0 0 6.128 4.318 4.318 0 0 0 3.064 1.269 4.318 4.318 0 0 0 3.064-1.264l7.66-7.66a4.332 4.332 0 0 0 0-6.133zm-1.532 4.6l-3.83 3.83-3.065-3.064L22.657 15a2.152 2.152 0 0 1 1.532-.635 2.15 2.15 0 0 1 1.532.635 2.152 2.152 0 0 1 .635 1.532 2.153 2.153 0 0 1-.635 1.526zm2.695 6.007a4.859 4.859 0 0 0-4.333 4.819 4.859 4.859 0 0 0 4.333 4.821zm1.084 0v9.642a4.859 4.859 0 0 0 4.333-4.821 4.859 4.859 0 0 0-4.333-4.821z"
});

var SvgMedicines = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMedicines, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/medicines.08770cea.svg";
export { ForwardRef as ReactComponent };